module.exports = __webpack_public_path__ + "static/media/Resume_JFM_ES.a34f957f.pdf";